import { HttpRequest } from "../utils";
import { FeePolicy, PolicyStatus } from "./tenantFeePolicy";

const httpRequest = new HttpRequest();

export interface AdminFeePolicyListParams {
  status?: PolicyStatus;
  page?  : number;
  limit? : number;
}

export interface AdminFeePolicyListResult {
  rows : FeePolicy[];
  total: number;
  page : number;
  limit: number;
}

export const listByTenant = (tenantId: string, params?: AdminFeePolicyListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get(`/bil/admin/tenants/${tenantId}/fee-policies`, params as any);

export const getByTenant = (tenantId: string, id: string) =>
  httpRequest.get(`/bil/admin/tenants/${tenantId}/fee-policies/${id}`);
